import { withChartLayout } from 'components/common';
import AdmissionHistory from 'components/features/chart/admission-history/admission-history/AdmissionHistory';

const AdmissionHistoryPage = withChartLayout('Admission History')(AdmissionHistory);
export default AdmissionHistoryPage;
